// extracted by mini-css-extract-plugin
export default {"component":"VideoBanner_component__E2cw4","card":"VideoBanner_card__qlC4y","content":"VideoBanner_content__bvSSe","icon":"VideoBanner_icon__e8i8+"};